module.exports = __webpack_public_path__ + "static/media/element1.e30187a7.svg";